import React, { useRef } from 'react';
import { CarouselPortraitProgress, ResponsiveImage } from '@/components';
import { ImageModel } from '@/types';

import Flicking from '@egjs/react-flicking';
import classNames from 'classnames';

type ImageCarouselLandscapeModel = {
  images: ImageModel[];
};

const ImageCarouselLandscape = ({ images }: ImageCarouselLandscapeModel) => {
  const [holding, setHolding] = React.useState(false);
  const carousel = useRef<Flicking>(null);

  const onCarouselMove = () => {
    const flicking = carousel.current;
    if (flicking) {
      const panels = flicking.visiblePanels;
      panels.forEach((panel) => {
        const progress = panel.outsetProgress;
        const el = panel.element;
        const target = el;
        target.style.transform = `scale(${1 - Math.abs(progress * 0.16)})`;
      });
    }
  };

  return (
    <div className="w-full pt-3">
      <Flicking
        ref={carousel}
        className={classNames(holding ? 'cursor-grabbing' : 'cursor-grab')}
        preventClickOnDrag
        preventDefaultOnDrag
        align="center"
        circular
        panelsPerView={1.75}
        interruptable
        onMove={onCarouselMove}
        onReady={onCarouselMove}
        onHoldStart={() => setHolding(true)}
        onHoldEnd={() => setHolding(false)}
      >
        {images.map((image, index) => (
          <div key={index} className="">
            <ResponsiveImage
              image={image}
              widths={{ xs: 375, sm: 768, md: 1024, lg: 1024, xl: 1264 }}
              heights={{ xs: 210, sm: 432, md: 576, lg: 576, xl: 711 }}
            />
          </div>
        ))}
      </Flicking>
      <div className="relative mt-8 w-full px-8 sm:-mt-4 lg:-mt-5 lg:px-32 md:[&_.progress-bar]:hidden">
        <CarouselPortraitProgress carousel={carousel} className="justify-between" />
      </div>
    </div>
  );
};

export default ImageCarouselLandscape;
